// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","primary":"Button_primary__9MLUH","not-active":"Button_not-active__GDFz2","disabled":"Button_disabled__DkgJ+"};